import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { DanoneMslProduct } from '../models/entities/danone-msl_product';
import { DanoneMslProductRequest } from '../models/dtos/danone-msl_product-request';
import { DanoneDnProductFamily } from '../models/entities/danone-dn-product-family';
import { DanoneDnProductFamilyRequest } from '../models/dtos/danone-dn-product-family-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


@Injectable({
  providedIn: 'root'
})


export class SalesAdminDanoneService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { 
  }
  
  danoneMslProductGet(geoAreaCode : string): Promise<DanoneMslProduct[]> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);
      request.strArg1			        = geoAreaCode;
     
      return new Promise((resolve, reject) => {
          this.networkService.post('sales/admin/danoneMslProductsGet', request).then(result => {
              return resolve(result.danoneMslProducts);
              
          }, error => {
              reject(error);
          });
      });
  }

  danoneMslProductSave(danoneMslProducts : DanoneMslProduct[]): Promise<DanoneMslProduct[]> {
    let request: DanoneMslProductRequest = new DanoneMslProductRequest(this.userService.userInfo);
    request.danoneMslProducts			 = danoneMslProducts;
   
    return new Promise((resolve, reject) => {
        this.networkService.post('sales/admin/danoneMslProductsSave', request).then(result => {
            return resolve(result.danoneMslProducts);
            
        }, error => {
            reject(error);
        });
    });
    }

   danoneMslProductInit(geoAreaCode : string): Promise<DanoneMslProduct[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1			        = geoAreaCode;
    
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/danoneMslProductInit', request).then(result => {
                return resolve(result.danoneMslProducts);
                
            }, error => {
                reject(error);
            });
        });
    }

//---------------------------------------------------------------------------------------------------------
  danoneDnProductFamiliesGet(): Promise<DanoneDnProductFamily[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/admin/danoneDnProductFamiliesGet', request).then(result => {
                return resolve(result.danoneDnProductFamilies);
                
            }, error => {
                reject(error);
            });
        });
  }
  
  danoneDnProductFamilyGet(code : string): Promise<DanoneDnProductFamily> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;

    return new Promise((resolve, reject) => {
        this.networkService.post('sales/admin/danoneDnProductFamilyGet', request).then(result => {
            return resolve(result.danoneDnProductFamily);
            
        }, error => {
            reject(error);
        });
    });
}

  

  danoneDnProductFamilySave(danoneDnProductFamily : DanoneDnProductFamily): Promise<DanoneDnProductFamily> {
    let request: DanoneDnProductFamilyRequest = new DanoneDnProductFamilyRequest(this.userService.userInfo);
    request.danoneDnProductFamily = danoneDnProductFamily;

    return new Promise((resolve, reject) => {
        this.networkService.post('sales/admin/danoneDnProductFamilySave', request).then(result => {
            return resolve(result.danoneDnProductFamily);
            
        }, error => {
            reject(error);
        });
    });
}
}

